import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const coachApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "coachApi",
  tagTypes: ["metric", "Answer"],
  endpoints: (builder) => ({
    //Tips
    getAllTips: builder.mutation<API.Response.CoachTipApiResponse, void>({
      query: (payload) => ({
        url: `/tips/all`,
        method: "POST",
        body: payload,
      }),
    }),

    getTip: builder.mutation<API.Response.CoachTipApiResponse, any>({
      query: (payload) => ({
        url: `/tips/gettip`,
        method: "POST",
        body: payload,
      }),
    }),

    //Forms
    getRequiredFields: builder.query({
      query: ({ formType, month, entity_no }) => {
        if (formType == "grow") {
          return { url: `/coach/template/${formType}?entity_no=${entity_no}&month=${month}` }
        }
        return { url: `/coach/template/${formType}` }
      },
    }),

    getSubmittedForms: builder.query<any, void>({
      query: () => `/coach/submissions`,
    }),

    submitCoachForm: builder.mutation<any, any>({
      query: ({ submissionData, formEndPoint }) => ({
        url: `/coach/template/${formEndPoint}`,
        method: "POST",
        body: submissionData,
      }),
    }),

    getSubmissionCount: builder.query({
      query: ({ type, month, entity_no }) => {
        if (type != "adhoc" && type != "ops_loss" && type != "dpmo" && type != "perception") {
          return { url: "" }
        }
        return { url: `coach/submissions/trend?type=${type}&month=${month}&entity_no=${entity_no}` }
      },
    }),

    coachSurvey: builder.mutation<any, any>({
      query: (payload) => ({
        url: "coach/survey",
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const {
  useCoachSurveyMutation,
  useGetAllTipsMutation,
  useGetRequiredFieldsQuery,
  useGetSubmissionCountQuery,
  useGetSubmittedFormsQuery,
  useGetTipMutation,
  useSubmitCoachFormMutation,
} = coachApi
